module.exports = __webpack_public_path__ + "static/media/recording-collaborator.0f963cec.svg";